import React, { useEffect } from 'react';
import { CheckCircle, Package, Home } from 'lucide-react';
import { SEO } from '../components/SEO';

const SuccessPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    // Clear cart after successful checkout
    localStorage.removeItem('raveRemedyCart');
  }, []);

  return (
    <>
      <SEO 
        title="Order Successful | RaveRemedy"
        description="Thank you for your RaveRemedy order! Your recovery supplements are on their way. Track your order and get ready for faster recovery."
      />
      <div className="min-h-screen bg-gradient-to-b from-black via-purple-900/20 to-black text-white flex items-center justify-center py-12">
        <div className="max-w-lg w-full mx-auto px-4">
          <div className="glass-panel rounded-3xl p-8 text-center">
            <div className="flex justify-center mb-6">
              <CheckCircle className="w-20 h-20 text-[#ff00ff]" />
            </div>
            
            <h1 className="text-3xl font-bold gradient-text mb-4">
              Thank You For Your Order!
            </h1>
            
            <p className="text-lg text-gray-300 mb-6">
              Your RaveRemedy is on its way to help you recover faster and feel better.
            </p>
            
            <div className="bg-white/5 rounded-xl p-6 mb-8">
            
              
              <div className="flex items-center mb-4">
                <Package className="w-5 h-5 text-[#ff66ff] mr-3 flex-shrink-0" />
                <p className="text-gray-300">Your order will be processed and shipped within 1-2 business days.</p>
              </div>
              
              <div className="flex items-center">
                <Home className="w-5 h-5 text-[#00ffff] mr-3 flex-shrink-0" />
                <p className="text-gray-300">Questions? Contact our support team at support@raveremedy.com</p>
              </div>
            </div>
            
            <div className="space-y-4">
              <a 
                href="/"
                className="block w-full bg-gradient-to-r from-[#ff00ff] via-[#ff66ff] to-[#00ffff] text-white px-6 py-3 rounded-xl font-bold hover:opacity-90 transition-all"
              >
                Return to Home
              </a>
              
              <a 
                href="/contact"
                className="block w-full bg-white/10 text-white px-6 py-3 rounded-xl font-bold hover:bg-white/20 transition-all"
              >
                Contact Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessPage;